import script from "./VideoInfoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoInfoDialog.vue?vue&type=script&setup=true&lang=js"

import "./VideoInfoDialog.vue?vue&type=style&index=0&id=78a4f415&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78a4f415"]])

export default __exports__